import React, { Fragment } from 'react';
import { Tooltip } from 'antd';
import cx from 'classnames';
import { WIDGET_TYPE_TEXT, WIDGET_TYPE_PERIOD_BAR_COLOR } from '../../../../../constants/service/app/widgetConstants';
import './WidgetPreviewThumbnail.scss';

const WidgetPreviewThumbnail = (props) => {
  const { isActive, widgetNo, widgetType, mainTitle, subTitle, scrollToTargetTop, ...res } = props;

  return (
    <div
      className={cx('widget-preview-thumbnail', { 'is-active': isActive })}
      style={{
        backgroundColor: WIDGET_TYPE_PERIOD_BAR_COLOR[widgetType].bgColor,
      }}
    >
      <Tooltip
        mouseLeaveDelay={0.0001}
        overlayStyle={{
          width: 'auto',
        }}
        title={
          mainTitle || subTitle ? (
            <Fragment>
              <div className="widget-preview-thumbnail-main-title">{mainTitle}</div>
              <div className="widget-preview-thumbnail-sub-title">{subTitle}</div>
            </Fragment>
          ) : (
            WIDGET_TYPE_TEXT[widgetType]
          )
        }
        {...res}
      >
        <div onClick={() => scrollToTargetTop()}>
          <div className="widget-no">{widgetNo}</div>
          <div className="widget-type">{WIDGET_TYPE_TEXT[widgetType]}</div>
        </div>
      </Tooltip>
    </div>
  );
};

export default WidgetPreviewThumbnail;
